import { createFileRoute } from '@tanstack/react-router';
import { RunDetail } from '~portal/components/admin/automations/runs/RunDetail';

/**
 * @desc One run (H2-7, task 8.4): header, step timeline, files, log tail, retry and cancel. A
 * sibling of the list rather than its child (`runs_`), as the Inspector's conversation view is.
 */
export const Route = createFileRoute('/_protected/admin/ario/runs_/$runId')({
  component: AutomationRunPage,
});

function AutomationRunPage() {
  const { runId } = Route.useParams();
  // Keyed so the confirmation state resets when following a retry to its new run.
  return <RunDetail key={runId} runId={runId} />;
}
